import { MdFavoriteBorder, MdFavorite } from 'react-icons/md';
import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';

export const Heart = ({ cardId }) => {
  const { handleFavoriteId, favoriteIds } = useContext(GlobalContext);
  const isFavorite = favoriteIds.includes(cardId);

  return (
    <button
      type='button'
      className='favorite-button'
      aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      onClick={e => {
        e.preventDefault();
        handleFavoriteId(cardId);
      }}
    >
      {isFavorite ? (
        <MdFavorite className='favorite-icon is-active' />
      ) : (
        <MdFavoriteBorder className='favorite-icon' />
      )}
    </button>
  );
};
